<template>
  <v-select
    class="pulse-input pulse-select"
    outlined
    dense
    hide-details
    :menu-props="{ offsetY: true, contentClass: 'pulse-select-menu' }"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template #append>
      <i class="pi pi-chevron-down pulse-input__icon" />
    </template>
  </v-select>
</template>

<script>
export default {
  name: "PulseSelect",
  inheritAttrs: false,
};
</script>
